import { render } from "./Collapsible.vue?vue&type=template&id=09bb9e86&scoped=true"
import script from "./Collapsible.vue?vue&type=script&lang=js"
export * from "./Collapsible.vue?vue&type=script&lang=js"

import "./Collapsible.vue?vue&type=style&index=0&id=09bb9e86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09bb9e86"]])

export default __exports__